import { useMap } from 'react-map-gl';
import { useEffect } from 'react';
import { useCaptureDebugData } from '.';
import { registerMapEventListeners } from './mapDebugData';

export const StoreDebugContextMapRef = (): JSX.Element | null => {
  const mapRef = useMap();
  const { debugContext } = useCaptureDebugData();

  // Whenever the current map instance changes, update the reference in `debugContext`.
  useEffect(() => {
    const map = mapRef.current?.getMap();
    if (!map) return () => {};
    debugContext.map = map;

    return registerMapEventListeners(map);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapRef.current, debugContext]);

  return null;
};
